// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1sH_p","footer":"ModalUpdate_footer__1PZkT"};